import { render } from "./UpdatePassword.vue?vue&type=template&id=1c54c6aa&scoped=true&ts=true"
import script from "./UpdatePassword.vue?vue&type=script&lang=ts"
export * from "./UpdatePassword.vue?vue&type=script&lang=ts"

import "./UpdatePassword.vue?vue&type=style&index=0&id=1c54c6aa&scoped=true&lang=scss"

import exportComponent from "D:\\02_システム\\20_帳票テンプレート\\02_開発\\report-template\\web-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c54c6aa"]])

export default __exports__